import { FuelPlanResponse } from "types";
import { FuelPlanFeedbackSnapshot } from "types/fuelPlanFeedback";
import type { DispatchFuelPlanResponse } from "./fuel-plan-response-adapter";
import { FuelPlanFeedbackOutcome } from "enums/fuelPlanFeedbackOutcome";
import { FuelPlanResponseStatus } from "enums/fuelPlanResponseStatus";

export const createResponseSnapshot = (
  response: FuelPlanResponse | DispatchFuelPlanResponse,
  attemptedAtUtc: string
): FuelPlanFeedbackSnapshot => ({
  attemptedAtUtc,
  generationId: response.generationId ?? null,
  outcome:
    response.status === FuelPlanResponseStatus.Ok
      ? FuelPlanFeedbackOutcome.Success
      : FuelPlanFeedbackOutcome.Unavailable,
  response,
  selectedFuelStopIds: {},
  httpStatus: null,
  failureMessage: null,
});

export const createFailureSnapshot = (
  httpStatus: number | undefined,
  failureMessage: string,
  attemptedAtUtc: string
): FuelPlanFeedbackSnapshot | null =>
  httpStatus === 409
    ? null
    : {
        attemptedAtUtc,
        outcome: FuelPlanFeedbackOutcome.RequestFailed,
        response: null,
        selectedFuelStopIds: {},
        httpStatus: httpStatus ?? null,
        failureMessage,
      };
